var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconcontactsaddressBook = function SvgIconcontactsaddressBook(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/contacts/icon.contacts.address_book") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/contacts/icon.contacts.address_book",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tabs",
    transform: "translate(25.000000, 5.000000)",
    stroke: "#09BE86",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 3.5,
    height: 4.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 7.75,
    width: 3.5,
    height: 4.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 14.75,
    width: 3.5,
    height: 4.5,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#09BE86",
    strokeWidth: 2,
    x: 2,
    y: 2,
    width: 24,
    height: 26,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bind",
    transform: "translate(0.500000, 5.500000)",
    stroke: "#09BE86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0.5,
    x2: 2.5,
    y2: 0.5,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 18.5,
    x2: 2.5,
    y2: 18.5,
    id: "Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Person",
    transform: "translate(9.000000, 6.000000)",
    stroke: "#09BE86",
    strokeWidth: 1.68421053
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5,
    cy: 4,
    r: 3.15789474
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69675365,15.9716511 C7.4581524,15.9716511 10,15.9716511 10,15.9716511 C10,11.9858256 7.76140987,8 5.00001112,8 C2.23861238,8 0,11.5008372 0,15.9716511 C-0.00852412447,16.0354361 1.93535491,15.9716511 4.69675365,15.9716511 Z",
    id: "Oval",
    strokeLinejoin: "round"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconcontactsaddressBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.contacts.address_book.0c64ccd2b107209a7fc9beb898e0ad84.svg";